export default __webpack_public_path__ + "static/media/forgot.57e8a243.png";